import * as Actions from 'store/actions/app/orders.actions'
import { addOrUpdateObjectInArray } from 'utils/add-or-update-object-in-array'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_orders: false,
  orders: [],
  total_orders: 0,

  loading_order: false,
  order: null,

  saving_order: false,
  saved_order: false,
  saved_order_data: null,

  finishing_order_register: false,
  finished_order_register: false,

  finishing_order_with_series_ids: [],
  finished_order_with_series_ids: [],

  voiding_order_ids: [],
  voided_order_ids: [],

  saving_order_from_proforma: false,
  saved_order_from_proforma: false,
}

const ordersReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ORDERS: {
      return {
        ...state,
        loading_orders: action.payload.loading ?? state.loading_orders,
        orders: action.payload.items ?? state.orders,
        total_orders: action.payload.total ?? state.total_orders,
      }
    }
    case Actions.GET_ORDER_BY_ID: {
      return {
        ...state,
        loading_order: action.payload.loading ?? state.loading_order,
        order: action.payload.data ?? state.order,
      }
    }
    case Actions.RESET_ORDER_BY_ID: {
      return { ...state, order: null }
    }
    case Actions.SAVE_ORDER: {
      return {
        ...state,
        saving_order: action.payload.saving ?? state.saving_order,
        saved_order: action.payload.saved ?? false,
        saved_order_data: action.payload.data ?? null,
        orders: action.payload.data
          ? addOrUpdateObjectInArray(state.orders, action.payload.data, 'pedido_nota_consumo_maestro_id', true)
          : state.orders,
      }
    }
    case Actions.FINISH_ORDER_REGISTER: {
      return {
        ...state,
        finishing_order_register: action.payload.finishing ?? state.finishing_order_register,
        finished_order_register: action.payload.finished ?? false,
        orders: action.payload.data
          ? addOrUpdateObjectInArray(state.orders, action.payload.data, 'pedido_nota_consumo_maestro_id')
          : state.orders,
      }
    }
    case Actions.FINISH_ORDER_WITH_SERIES: {
      return {
        ...state,
        finishing_order_with_series_ids: toggleIdInArray(state.finishing_order_with_series_ids, action.payload.finishing_id),
        finished_order_with_series_ids: toggleIdInArray(state.finished_order_with_series_ids, action.payload.finished_id),
        orders: action.payload.data
          ? addOrUpdateObjectInArray(state.orders, action.payload.data, 'pedido_nota_consumo_maestro_id')
          : state.orders,
      }
    }
    case Actions.VOID_ORDER: {
      return {
        ...state,
        voiding_order_ids: toggleIdInArray(state.voiding_order_ids, action.payload.voiding_id),
        voided_order_ids: toggleIdInArray(state.voided_order_ids, action.payload.voided_id),
        orders: action.payload.data
          ? addOrUpdateObjectInArray(state.orders, action.payload.data, 'pedido_nota_consumo_maestro_id')
          : state.orders,
      }
    }
    case Actions.SAVE_ORDER_FROM_PROFORMA: {
      return {
        ...state,
        saving_order_from_proforma: action.payload.saving ?? state.saving_order_from_proforma,
        saved_order_from_proforma: action.payload.saved ?? false,
        orders: action.payload.data
          ? addOrUpdateObjectInArray(state.orders, action.payload.data, 'pedido_nota_consumo_maestro_id', true)
          : state.orders,
      }
    }
    default: {
      return state
    }
  }
}

export default ordersReducer
